import React from 'react';
import PropTypes from 'prop-types';

import Img from '../../Img';

import styles from './ratingInfo.scss';

const PickleballRatingInfoContent = props => {
    const { isMobile, cancelText, closePopUp } = props;

    return (
        <div className="pop-up-content">
            <div className={styles.titleWrapper}>
                <div className={styles.title}>UTR Pickleball Rating (UTR-P)</div>
                {!isMobile && (
                    <Img
                        alt="close"
                        src="/img/v2/icons/icon-close.svg"
                        className={styles.closeIcon}
                        onClick={closePopUp}
                    />
                )}
            </div>
            <div className="row mb24">
                <div className="col">
                    <div className={styles.descTitle}>
                        UTR Pickleball Rating (UTR-P)
                    </div>
                    <div className={styles.desc}>
                        UTR-P Ratings are on a scale from 1-10 when players have match results and P1-P5 categories when players do not yet have match results.
                    </div>
                </div>
            </div>
            <div className="row mb24">
                <div className="col">
                    <div className={styles.descTitle}>
                        Verified UTR-P Rating
                    </div>
                    <div className={styles.desc}>
                        When you see the Verified check mark, the rating is calculated from organized event results. This rating can be either singles or doubles.
                    </div>
                </div>
            </div>
            <div className="row mb24">
                <div className="col">
                    <div className={styles.descTitle}>
                        UTR-P Rating
                    </div>
                    <div className={styles.desc}>
                        The UTR-P Rating is calculated using results from a broader range of event types, including self-posted scores, casual play, verified matches, and practice matches. This rating does not have a checkmark and can be either singles or doubles.
                    </div>
                </div>
            </div>
            <div className="row mb24">
                <div className="col">
                    <div className={styles.descTitle}>
                        Reliable/Projected UTR-P Rating
                    </div>
                    <div className={styles.desc}>
                        When you see “Reliable” there are enough results to have confidence in the rating. When you see “Projected” then it means there are not yet enough results to have complete confidence in the rating, but there are enough results to display a projection. Approximately 4-6 results are needed before a rating becomes fully reliable.
                    </div>
                </div>
            </div>
            <div className="row mb24">
                <div className="col">
                    <div className={styles.descTitle}>
                        Estimated UTR-P
                    </div>
                    <div className={styles.desc}>
                        If you see a P1-P5, then it is an estimate of the player's eventual rating based upon self-reported answers to our pickleball survey questions. The different categories are P1 - Beginner; P2 - Social/Casual; P3 - Intermediate; P4 - Advanced; P5 - Expert/Pro.
                    </div>
                </div>
            </div>
            <div className="row mb24">
                <div className="col">
                    <div className={styles.descTitle}>
                        Last Known Rating
                    </div>
                    <div className={styles.desc}>
                        When you see a month and year abbreviation beneath a rating (i.e. Apr '21), this is the player’s last known reliable rating from within the last 2 years.
                    </div>
                </div>
            </div>
            <div className="row mb24">
                <div className="col-12 text-center">
                    <a
                        href="https://support.universaltennis.com/support/solutions/articles/9000233026-the-utr-pickleball-rating-utr-p"
                        onClick={(e) => {
                            e.preventDefault();
                            e.stopPropagation();
                            window.open(
                                e.currentTarget.href,
                                '_blank',
                                'noopener,noreferrer',
                            );
                        }}
                    >
                            Click here
                    </a> to learn more.
                </div>
            </div>
            <div className="text-right">
                <button
                    type="button"
                    onClick={closePopUp}
                    className={`btn btn-primary text-uppercase text-white`}
                >
                    <span>{cancelText}</span>
                </button>
            </div>
        </div>
    );
};

PickleballRatingInfoContent.propTypes = {
    isMobile: PropTypes.bool.isRequired,
    cancelText: PropTypes.string.isRequired,
    closePopUp: PropTypes.func.isRequired,
};

export default PickleballRatingInfoContent;
